import React from 'react';
import './CTABox.css';

const CTABox = ({ title, description, buttonText = 'Get Started', buttonLink = '#', badge, subtext }) => {
  if (!title && !description) return null;

  return (
    <div className="cta-box">
      <div className="cta-box__content">
        {badge && <span className="cta-box__badge">{badge}</span>}
        {title && <h3>{title}</h3>}
        {description && <p>{description}</p>}
        {subtext && <small>{subtext}</small>}
      </div>
      {buttonText && (
        <a className="cta-box__button" href={buttonLink}>
          {buttonText}
        </a>
      )}
    </div>
  );
};

export default CTABox;
